module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-2.e19b00a7.jpg";